import { Container } from '@chakra-ui/react';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { DashboardTabs } from '@/components/dashboard/DashboardTabs';

const dashboardSearchSchema = z.object({
  tab: z.string().catch('main'),
});

export const Route = createFileRoute('/_layout/$slug/dashboard/')({
  component: Dashboard,
  validateSearch: (search) => dashboardSearchSchema.parse(search),
});

function Dashboard() {
  return (
    <Container maxW="full" maxH="100vh" overflow={'hidden'} p={0}>
      <DashboardTabs />
    </Container>
  );
}
